export default function PlatformInfo() {
  return (
    <section className="py-5 bg-light">
      <div className="container">
        {/* Section header */}
        <div className="text-center mb-5">
          <h2 className="fw-bold">Why Choose Our Platform</h2>
          <p className="text-muted mt-2">
            Built with modern tools to help you grow faster and smarter.
          </p>
        </div>

        {/* Cards */}
        <div className="row g-4">
          {/* Card 1 */}
          <div className="col-12 col-lg-4">
            <div className="card h-100 shadow-sm border-0">
              <div className="card-body text-center">
                <i className="bi bi-lightning-charge fs-1 text-primary mb-3" />
                <h5 className="card-title fw-semibold">
                  Fast & Reliable
                </h5>
                <p className="card-text text-muted">
                  Our platform is optimized for speed and reliability, ensuring
                  a smooth experience across all devices.
                </p>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-12 col-lg-4">
            <div className="card h-100 shadow-sm border-0">
              <div className="card-body text-center">
                <i className="bi bi-shield-lock fs-1 text-primary mb-3" />
                <h5 className="card-title fw-semibold">
                  Secure by Design
                </h5>
                <p className="card-text text-muted">
                  Security is built into every layer, protecting your data and
                  giving you peace of mind.
                </p>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-12 col-lg-4">
            <div className="card h-100 shadow-sm border-0">
              <div className="card-body text-center">
                <i className="bi bi-graph-up fs-1 text-primary mb-3" />
                <h5 className="card-title fw-semibold">
                  Scalable Growth
                </h5>
                <p className="card-text text-muted">
                  Designed to scale with your needs, from small projects to
                  enterprise-level applications.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
